
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';
import { clientQuery } from 'Core/data/GraphQLApi';

//```import constants types
import {
    VIDFLEET_POWER_LOST_REQUEST
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';

import { powerLostResult } from 'Redux/actions';


function* powerLost({ payload }) {
    try {
        const { filters } = payload;
        let startDate = filters.startDate
        let endDate = filters.endDate

        let count = +filters.limit;
        let from = +filters.from;
        let hasMore = filters.hasMore;

        let QUERY = `
            query getPowerLostEvents($esn: String, $from: Int!, $count: Int!, $dateRange: AWSDateTimeRange){
                result: getPowerLostEvents(esn: $esn, from: $from, count: $count, dateRange: $dateRange)
            }
        `

        let dateRange = null

        if (filters?.filterByDate) {
            dateRange = {
                start: startDate,
                end: endDate
            }
        }

        let data = yield call(
            clientQuery,
            QUERY,
            {
                esn: filters.esn || null,
                from: from,
                count: count,
                dateRange: dateRange
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            let result = JSON.parse(data?.result)
            yield put(powerLostResult({ result, error: null, hasMore }));
        }else {
            yield put(powerLostResult({ result: {powerEvents: []}, error: null, hasMore }));
        }
        
    } catch (exc) {
        yield put(powerLostResult({ error: true, errorCode: exc.request?.status }));
        ExceptionManager(
            exc,
            "Modules/vidFleet/components/powerLost/redux/saga",
            "powerLost",
        )
    }
}

function* watchMethods() {
    yield takeEvery(VIDFLEET_POWER_LOST_REQUEST, powerLost);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}